import { Component, Inject, OnInit } from '@angular/core';
import { MATERIAL_ICONS_BY_CATEGORY } from './material-icons';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-icon-select-modal',
  templateUrl: './icon-select-modal.component.html',
  styleUrls: ['./icon-select-modal.component.scss']
})
export class IconSelectModalComponent implements OnInit {
  materialIconsByCategory = MATERIAL_ICONS_BY_CATEGORY;
  selectedIcon: string | null = null;
  searchTerm: string = '';
  filteredIconsByCategory: { [key: string]: string[] } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) data
  ) { 
    this.selectedIcon = data?.selectedIcon || null;
  }

  ngOnInit(): void {
    this.filteredIconsByCategory = { ...this.materialIconsByCategory };
  }

  onSearchChange(): void {
    if (!this.searchTerm.trim()) {
      this.filteredIconsByCategory = { ...this.materialIconsByCategory };
      return;
    }

    const searchLower = this.searchTerm.toLowerCase();
    this.filteredIconsByCategory = {};

    Object.keys(this.materialIconsByCategory).forEach(category => {
      const filtered = this.materialIconsByCategory[category].filter(icon =>
        icon.toLowerCase().includes(searchLower)
      );
      if (filtered.length > 0) {
        this.filteredIconsByCategory[category] = filtered;
      }
    });
  }

}
